export const StatusCode = {
  USER_NOT_FOUND: 103,
  USER_IS_NOT_ANONYMOUS: 6001,
  MSISDN_IS_IN_USE: 6002,
  EMAIL_IS_IN_USE: 6003,
  AUTHENTICATION_ERROR: 6009,
  WRONG_OTP: 6010,
  BASKET_SETTINGS_MISMATCH: 8002,
  VODAFONE_PAYMENT_PASSIVE: 8016,
  RECEIVER_INFORMATION_MISSING: 8018,
  SENDER_INFORMATION_MISSING: 8019,
};
